"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webview_app_1 = require("@/webview_app");
const _1 = require(".");
function default_1({ data, message }) {
    const { isNativeApp } = window;
    if (isNativeApp) {
        (0, webview_app_1.postMessageToWVA)(`CLIPBOARD::${data}`);
    }
    else {
        navigator.clipboard.writeText(data);
    }
    (0, _1.showToastMessage)({ message });
}
exports.default = default_1;
